module.exports = __webpack_public_path__ + "img/Spend Dashboard.596ad68d.svg";